import { render, staticRenderFns } from "./accountSys.vue?vue&type=template&id=08fd6254&scoped=true&"
import script from "./accountSys.vue?vue&type=script&lang=js&"
export * from "./accountSys.vue?vue&type=script&lang=js&"
import style0 from "./accountSys.vue?vue&type=style&index=0&id=08fd6254&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fd6254",
  null
  
)

export default component.exports